<style lang="scss" scoped>
	@import "./mobileaccount.css";

</style>
<style>
	.grayc{
		color: #cfcfcf !important;
	}
	.greenc{
		/* color: #0c8b97 !important; */
		color: #808080 !important;
	}
</style>
<style lang='scss'>
	#bankinformation .ant-popover-message .ant-popover-message-title {
	    padding-left: 0 !important;
		font-size: .8rem;
	}
	#mobileaccount .ant-popover-inner-content{
		    padding: 0.6rem 0.4rem;
		    font-size: 0.73rem;
	}
	#mobileaccount {
		.popoverView .ant-popover-inner-content {
		    padding: 0;
		}
		
		.ant-btn-sm{
			width: 2.8rem;
			height: 1.5rem;
			span{
				font-size: .7rem !important;
			}
		}
		
		
		
		.ant-popover-inner-content {
		    background-color: #fcfcfc;
			padding: 10px;
		}
		.ant-btn-primary{
			background-color: #14666F;
		}
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>
<template>
	<div id="mobileaccount">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<div style='display:flex;justify-content:space-between;'>
							<div style="width: 25%;">
								<a-form-model-item label="銀行名稱" class="formItem">
									<a-input v-model="params.bankname" placeholder="請輸入銀行名稱" :allowClear="true" @change="handleClear(1)" />
								</a-form-model-item>
							</div>
                            <div style="width: 25%;">
							<a-form-model-item label="帳戶名稱" class="formItem">
								<a-input v-model="params.accountname" placeholder="請輸入帳戶名稱" :allowClear="true" @change="handleClear(2)" />
							</a-form-model-item>
							</div>
							<div style="width: 25%;">
								<a-form-model-item label="貨幣幣種" class="formItem">
									<!-- <a-select v-model="params.ccytype" placeholder="請選擇" @change="searchEvent" style='width: 10rem;'>
										<a-select-option v-for="(item) in admintypeArr" :key="item.key"
											:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
									</a-select> -->
									<Situationall v-model="params.ccytype" :url='$api.getparas' ref='seachope' :val='params.ccytype'
										:params='{"type":"bankinfoccytype"}' :style='"width:100%"' :placeholder="'請選擇貨幣幣種'">
									</Situationall>
								</a-form-model-item>
							</div>
							
				</div>
				<br>
				<div style='display:flex;justify-content:space-between;'>
					<div style="width: 25%;">
						<a-form-model-item label="戶口狀態" class="formItem">
							<a-select v-model="params.status" placeholder="請選擇" @change="searchEvent" style='width: 100%;'>
								<a-select-option v-for="(item) in admintypeArr" :key="item.key"
									:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<!-- <div>
							<a-form-model-item label="國家/地區" class="formItem">
								<Situationall v-model="params.area" :url='$api.getParamList' ref='seachope'
									:params='{"type":"kharea"}' :style='"width:8rem"' :placeholder="'請選擇國家/地區'">
								</Situationall>
						</a-form-model-item>
					</div> -->
					<div  style="width: 25%;">
						<a-form-model-item label="操作時間" class="formItem">
							 <!-- <a-date-picker @change='fanhand' format="YYYY/MM/DD"  placeholder="請選擇操作時間"
								v-model="params.handletime" /> -->
								<a-range-picker :placeholder="['開始日期','結束日期']" format="YYYY/MM/DD"
									v-model="params.handletime" @change='fanhand'>
								</a-range-picker>
						</a-form-model-item>
					</div>
					<div style="width: 25%;">
					<div
						style="display: inline-flex;align-items: center;">
						<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
							<img src="../../image/icon_sousuo.png" class="btnIcon" />
							<span>搜索</span>
						</div>
						<div class="btn_cla" style="background-color:#ffa647 !important;"
							@click="clearEvent">
							<img src="../../image/icon_chongzhi.png" class="btnIcon" />
							<span>重置</span>
						</div>
					</div>
					</div>
				</div>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<div @click='visible_bold = 1' v-if='domaininsertadmin' class='btn_list'>
					<img src="../../image/emp1.png" class="btnIcon" />
					<span style="color: #ffa647;">添加</span>
				</div>
				<a-upload name="file" :data='{token:$store.state.token}' :headers='{token:$store.state.token}'
					class="avatar-uploader" :show-upload-list="false" :action="$api.importBankInformationExcel"
					:before-upload="beforeUpload" @change="handleChange"  v-if='domaininsertadmin'>
					<div class='btn_list' >
						<img src="../../image/endexs.png" class="btnIcon"/>
						<span style="color:rgb(93, 176, 234);">導入</span>
					</div>
				</a-upload>
				<div @click="upClick()" class='btn_list'>
					<a-icon type="file-pdf" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem'/>
					<span style="color:#3bc7a1;">導出</span>
				</div>
				<!-- <task :params='params' @child='fandfn' v-if='domaineditadmin'></task> -->
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index' :customRow='rowstely'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='alltext' style="font-size: 0.85rem;position: relative;left: 1.2rem;">受款帳戶中/英文名稱
					<span style="font-size: 0.85rem;position: relative;left: -11rem;"></span>
				</span>
				<div slot='mobileservice' slot-scope='record'>
				<div v-if='record.bankname_cn'>{{record.bankname_cn}}</div>
				{{record.bankname_en}}
				</div>
				<div slot='accountname_cn' slot-scope='record'  style="left: 1.2rem;position: relative;">
				<div v-if='record.accountname_cn'>{{record.accountname_cn}}</div>
				{{record.accountname_en}}</div>
				<div slot='address_cn' slot-scope='record' >
				{{record.address_cn}}
				<br>
				{{record.address_en}}</div>
				<div slot='accountnumberList' slot-scope='record' >
				<span v-for='(item,ind) in record.accountnumberList'>{{item.ccytype}}<span v-if='ind+1!==record.accountnumberList.length'> / </span></span>
				</div>
				
				<!-- style="margin-left: 4rem;text-align: left;" -->
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div v-if='false'>
							<img :src="record.visible_bold !== 1?require('../../image/lea/bianji1.png'):require('../../image/lea/bianji3.png')"
							 class="imageb" @click='handediot(record,1)' v-if='domaineditadmin' :style="{opacity:record.status == '已過期'?'.5':'1'}">
						</div>
						<div class="popoverView" v-if='domaininsertadmin||domaineditadmin'>
							<img :src="record.visible_bold1 !== 2?require('../../image/lea/chakan1.png'):require('../../image/lea/chakan.png')" 
							 class="imageb" @click='handediot(record,2)'
							:style="{opacity:record.status == '已過期'?'.5':'1'}">
							<!-- <ediotitem :record='record' :missionflag='params.missionflag' @child='handclose'></ediotitem> -->
						</div>
							<div class="popoverView"  v-if='record.status == "已過期"||record.status == 0'>
							<img :src="require('../../image/openbtn.png')" class="imageC" style="width: 1.25rem;" @click='openbtn(record)'>
							</div>
						<div class="popoverView" v-else >
							<!--  v-if='domaineditadmin' -->
						<!-- 	 <a-popconfirm 
							 title='確定關閉帳戶？'
								ok-text="確定"
							    cancel-text="取消"
								placement="topRight" 
							    @confirm="deletefn(record)"
							    @cancel="cancel"> -->
							  <!-- <template slot='title' id='bankinformation' style="padding: 0;"></template > -->
								<!-- <a-icon slot="icon" type="question-circle-o" style="color: red;display: none;" /> -->
							    <img @click='deletefn(record)' :src="require('../../image/gethelp.png')" class="imageC" style="width: 1.25rem;">
							  <!-- </a-popconfirm> -->
						</div>
					</div>
				</div>
			</a-table>
			<!--  -->
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
			<div class="pdfviewIn">
				<div class="pdfTitle">
					<img @click.stop="printEvent()" src="../../image/icon_dayin.png">
				</div>
				<iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
				<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
			</div>
		</div>
		<handItem v-if='visible_bold==1' @child='handclose' :items='isdate'></handItem>
		<handItems v-if='visible_bold==2' @child='handclose' :items='isdate'></handItems>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
	</div>
</template>
<script>
	import exportData from "./components/exportData";
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	import ediotitem from './components/ediotitem.vue'
	import handItem from './components/handItem'
	import handItems from './components/handItems'
	import {
		saveFileToLink
	} from 'web-downloadfile';
	import task from './components/task.vue'

	export default {
		components: {handItem,task,ediotitem,handItems,exportData},
		data() {
			return {
				upFlag:false,
				ishandout: false,
				allurl: '',
				pdfShow: false,
				pdfBolUrl: '',
				isdate:'',
				visible_bold:'',
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限    
				ipoAdmin: true,
				// this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				icon_pdf,
				icon_pdf1,
				//移動服務新增管理 mobilserinsertadmin
				//移動服務編輯管理 mobilsereditadmin
				domaininsertadmin: true,
				 // this.$store.state.rolesdata.indexOf('mobilserinsertadmin') >= 0,
				domaineditadmin:  true,
				// this.$store.state.rolesdata.indexOf('mobilsereditadmin') >= 0,
				admintypeArr: [{
						text: '全部',
						value: ''
					// },{
					// 	text: '多種貨幣',
					// 	value: '多種貨幣'
					// },
					// {
					// 	text: '港元',
					// 	value: '港元'
					// },{
					// 	text: '人民幣及美元',
					// 	value: '人民幣及美元'
					// },{
					// 	text: '港元及美元',
					// 	value: '港元及美元'
					},{
						text: '正常',
						value: '1'
					},{
						text: '關閉',
						value: '0'
					}],
				tzPageNum: '',
				columns: [
					// {
					// 	// title: '',
					// 	dataIndex: '',
					// 	align: 'right',
					// 	width: '5%',
					// 	slots:{
					// 		title:'alltext'
					// 	}
					// },
					{
						// title: '',
						dataIndex: '',
						align: 'left',
						width: '21%',
						scopedSlots:{
							customRender:'accountname_cn'
						},
						slots:{
								title:'alltext'
						 	}
					},
					{
						title: '收款銀行中/英文名稱',
						dataIndex: '',
						align: 'left',
						width: '21%',
						scopedSlots:{
							customRender:'mobileservice'
						},
						
					},
					
					
					{
						title: '銀行地址中/英文名稱',
						dataIndex: '',
						align: 'left',
						width: '23%',
						scopedSlots:{
							customRender:'address_cn'
						}
					},
					{
						title: '貨幣幣種',
						dataIndex: '',
						align: 'left',
						width: '10%',
						scopedSlots:{
							customRender:'accountnumberList'
						}
					},
					{
						title: '操作人',
						dataIndex: 'realname',
						align: 'center',
						width: '7%',
					},{
						title: '操作時間',
						dataIndex: 'handletime',
						align: 'left',
						width: '10%',
					},{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10,	 //每頁條目數
					bankname:'',
					accountname:'',
					area:'',
					ccytype:'',
					handletime:[],
					begindate:'',
					enddate:'',
					status:''
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
		},
		methods: {
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.pdfEvent(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			// 表格导出下载
			queryData(pxfs){
				let brr  = []
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['bankid']){
						brr.push(this.columnsData[ev]['bankid'])
					}
				})
				let url = this.$api.bankInformation;
				let sort =  pxfs == undefined ? '' : pxfs
				// url += '?m=' + Date.parse(new Date())
				url += '?token=' + this.$store.state.token 
				+ '&m=' + Date.parse(new Date()) 
				+ '&bankname=' + this.params.bankname
				+ '&accountname=' + this.params.accountname
				+ '&ccytype=' + this.params.ccytype
				+ '&begindate=' + this.params.begindate
				+ '&enddate=' + this.params.enddate
				+ '&sort=' + sort
				+ '&bankidList=' + brr.join(',')
				+ '&status=' +this.params.status
				console.log(url);
				window.location.href = url;
			},
			upClick(){
				this.upFlag = true
			},
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
				if (val == 1) {
					if (!this.params.bankname) {
						this.messLoad()
					}
				}
				if (val == 2) {
					if (!this.params.accountname) {
						this.messLoad()
					}
				}
            },
			pdfEvent(pxfs) {
				let brr  = []
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['bankid']){
						brr.push(this.columnsData[ev]['bankid'])
					}
				})
				
				let str = this.$api.pdfs; //getUnsk
				let url = this.$api.getQmisBankInfoPdf;
				let sort =  pxfs == undefined ? '' : pxfs
				// url += '?m=' + Date.parse(new Date())
				url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) 
				+ '&bankname=' + this.params.bankname
				+ '&accountname=' + this.params.accountname
				+ '&ccytype=' + this.params.ccytype
				+ '&begindate=' + this.params.begindate
				+ '&enddate=' + this.params.enddate
				+ '&sort=' + sort
				+ '&bankidList=' + brr.join(',')
				+ '&status=' +this.params.status
				this.allurl = str + url
				
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});
			    //
				setTimeout(() => {
					this.pdfShow = true;
				}, 500);
				// window.open(this.$api.openurls+ "/dalinji")
			},
			printEvent() {
				let _this = this; //toPrintIframe
				const printIframe = document.getElementById("toPrintIframe");
				let frameWindow = printIframe.contentWindow;
				console.log(frameWindow)
				frameWindow.print();
				setTimeout(() => {
					window.URL.revokeObjectURL(_this.blob);
				}, 500)
			},
			pdfShowUNEvent() {
				this.pdfShow = false;
				// this.messLoad();
			},
			disabledStartDate(startValue) {
				if(this.params.timeDate1[1]){
					const endValue = this.params.timeDate1[1];
					console.log(this.params.timeDate1[1])
					if (!startValue || !endValue) {
					  return false;
					}
					return startValue.valueOf() < endValue.valueOf();
				}
			  },
			rowstely(record, index) {
				if (record.status == "已過期"||record.status == 0) {
					return {
						style: {
							'color': '#999',
							opacity: '.5'
						},
					}
				}
			},
			uploadfn(val,a){
				if(a){
					if(this.params.register_date_sort == 'up'){
						this.params.register_date_sort = 'down'
					}else if(this.params.register_date_sort == 'down'){
						this.params.register_date_sort = ''
					}else if(this.params.register_date_sort == ''){
						this.params.register_date_sort = 'up'
					}
				}else{
					if(this.params.expire_date_sort == 'up'){
						this.params.expire_date_sort = 'down'
					}else if(this.params.expire_date_sort == 'down'){
						this.params.expire_date_sort = ''
					}else if(this.params.expire_date_sort == ''){
						this.params.expire_date_sort = 'up'
					}
				}
				this.messLoad();
			},
			cancel(){},
			openbtn(ev){
				this.$ajax({
					method:'post',
					url:this.$api.isNoUseBank,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"token":this.$store.state.token,
						 "bankid":ev.bankid,
						 "status":1  // 0 停用 1 使用
					}
				}).then(res=>{
					if (res.data.qmiscode === 1000) {
						this.$message.success('操作成功')
						this.messLoad();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},
			deletefn(ev){
				this.$ajax({
					method: 'post',
					url: this.$api.isNoUseBank,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"token":this.$store.state.token,
						"bankid":ev.bankid,
						"status":0  // 0 停用 1 使用
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.$message.success('操作成功')
						this.messLoad();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handediot(val,a){
				this.isdate = val.bankid;
				// console.log(val)
				this.visible_bold = a;
				if(a==1){
					val.visible_bold = a
				}else{
					val.visible_bold1 = a
				}
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			fandfn(val){
				if(val == 'back'){
					this.params.missionflag = 0
					this.params.status = ''
				}else{
					this.params.missionflag = 1
					this.params.status = val == '即將到期'?'3':''
				}
				this.messLoad()
			},
			handopen(){
				window.location.href = this.$api.getExcel+'?token=' +this.$store.state.token
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
		
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.begindate = this.params.handletime[0] ? App.oDate.secsTime3(this.params.handletime[0]._d) : '';
				this.params.enddate = this.params.handletime[1] ? App.oDate.secsTime3(this.params.handletime[1]._d) : '';
			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handclose(val) {
				this.isdate = ''
				this.visible_bold = '';
				this.columnsData.map(ev => {
					for (let key in ev) {
						ev['visible_bold'] = ''
						ev['visible_bold1'] = ''
					}
				})
				if (val) {
					this.messLoad();
				}
			},
			messLoad() {
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.adminbank,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.qmisBankInfoList
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['visible_bold'] = ''
								ev['visible_bold1'] = ''
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.bankname || this.params.accountname || this.params.ccytype || this.params.status || this.params.begindate) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
						console.log(this.params)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					App.oTool.warningT(err.data.qmismsg);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},

			clearEvent() {
				this.params = {}
				this.params = {
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10,	 //每頁條目數
					bankname:'',
					accountname:'',
					area:'',
					ccytype:'',
					handletime:[],
					begindate:'',
					enddate:'',
					status:''
				}
				this.$refs['seachope'].zerostr()
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>
